const GC = {
    lang: 'en',

    async init() {

        this.showLoading();
        this.detectInitialLang();

        // Show alternate output for restricted countries
        const userCountry = await this.getCountryISO();
        const restrictedCountries = this.getRestrictedCountries();

        if (restrictedCountries.includes(userCountry)) {
            this.showAlternateOutput();
        }

        requestAnimationFrame(() => {
            setTimeout(() => {
                this.hideLoading();
            }, 400);
        });

        this.initCarousel();
        this.initZoom();
        this.initToggles();
        this.initLanguageSwitcher();
        this.applyTranslations();
        this.renderExtraSustainabilityPictures();

    },

    getRestrictedCountries() {
        return Array.isArray(window.restrictedCountries)
            ? window.restrictedCountries
            : (typeof window.restrictedCountries === 'string' && window.restrictedCountries.length > 0
                ? window.restrictedCountries.split(',')
                : [])
    },

    detectInitialLang() {
        const urlLang = new URLSearchParams(window.location.search).get("iso_lang");
        if (urlLang) {
            this.lang = urlLang;
            return;
        }

        const browserLang = (navigator.language || "en").split("-")[0];

        const langCodesEl = document.getElementById("gc-language-map");
        if (!langCodesEl) {
            this.lang = "en";
            return;
        }

        let supportedLangs = [];
        try {
            supportedLangs = JSON.parse(langCodesEl.dataset.langCodes);
        } catch (e) {
            console.warn("Could not parse lang codes:", e);
            this.lang = "en";
            return;
        }

        this.lang = supportedLangs.includes(browserLang) ? browserLang : "en";
    },

    showLoading() {
        const container = document.querySelector(".gc-product-sheet");
        const loader = document.getElementById("gc-loading");
        if (container) container.classList.add("gc-blurred");
        if (loader) loader.style.display = "flex";
    },

    hideLoading() {
        const container = document.querySelector(".gc-product-sheet");
        const loader = document.getElementById("gc-loading");
        if (container) container.classList.remove("gc-blurred");
        if (loader) loader.style.display = "none";
    },

    applyTranslations() {
        document.querySelectorAll("[data-trans]").forEach(el => {
            try {
                const data = JSON.parse(el.dataset.trans);
                const lang = this.lang || "en";

                if (
                    typeof data === "object" &&
                    !Array.isArray(data)
                ) {
                    let value;

                    if ("en" in data || "es" in data) { // unidimensional json
                        value = data[lang] || data["en"] || data["es"] || "";
                    } else { // for multidimensional json
                        const parts = [];

                        for (const key in data) {
                            const val = data[key]?.[lang] || data[key]?.en || data[key]?.es || "";
                            if (val) parts.push(val);
                        }

                        value = parts.join(" / ");
                    }

                    el.textContent = value;
                }
            } catch (e) {
                console.warn("Invalid data-trans JSON:", el.dataset.trans);
            }
        });

        this.renderIngredients();
    },

    renderIngredients() {
        const container = document.querySelector("#gc-ingredients-json");
        const output = document.querySelector("#gc-ingredients-render");

        if (!container || !output) return;
        const boldInsideParentheses = {
            en: "sulphites",
            es: "sulfitos",
            bg: "сулфити",
            cs: "siřičitany",
            da: "sulfitter",
            de: "Sulfite",
            et: "sulfitid",
            el: "θειώδη",
            fr: "sulfites",
            ga: "sulfites",
            hr: "sulfiti",
            it: "solfiti",
            lv: "sulfīti",
            lt: "sulfitai",
            hu: "szulfitok",
            mt: "sulfiti",
            nl: "sulfieten",
            pl: "siarczyny",
            pt: "sulfitos",
            ro: "sulfiți",
            sk: "siričitany",
            sl: "sulfiti",
            fi: "sulfiitit",
            sv: "sulfiter"
        };


        try {
            const rawJson = JSON.parse(container.textContent.trim());
            const ingredients = Object.entries(rawJson); // entries = [ [key, value], ... ]
            const grouped = {};
            const lang = this.lang || "en";

            ingredients.forEach(([key, ing]) => {
                const type = ing.tipo?.[lang] || ing.tipo?.en || ing.tipo?.es || "sin tipo";
                const valueRaw = ing[lang] || ing.en || ing.es || "";

                const value = valueRaw.charAt(0).toLowerCase() + valueRaw.slice(1);
                const keyword = boldInsideParentheses[lang];

                const highlighted = key === "IN18"
                    ? `<strong>${value}</strong>`
                    : (keyword && value.includes(keyword)
                        ? value.replace(new RegExp(`(${keyword})`, "gi"), "<strong>$1</strong>")
                        : value);

                if (!grouped[type]) grouped[type] = [];

                grouped[type].push(highlighted);
            });

            const finalString = Object.entries(grouped).map(([type, values]) => {
                return type === "sin tipo"
                    ? values.join(", ")
                    : `${type.toLowerCase()} (${values.join(", ")})`;
            }).join(", ");

            output.innerHTML = finalString.charAt(0).toUpperCase() + finalString.slice(1);

        } catch (e) {
            console.warn("Error parsing ingredients JSON", e);
        }
    },


    initCarousel() {
        const $carousel = $(".gc-slick-carousel");
        $carousel.slick({
            dots: !$carousel.hasClass("only-one"),
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            swipe: true,
            touchMove: true,
            lazyLoad: "anticipated",
        });
    },

    initZoom() {
        const isMobile = window.matchMedia("(pointer: coarse)").matches;

        document.querySelectorAll(".gc-zoom-wrapper").forEach(wrapper => {
            const img = wrapper.querySelector(".gc-zoom-img");
            let zoomed = false;

            wrapper.addEventListener("click", e => {
                e.preventDefault();
                zoomed = !zoomed;

                const zoomFactor = isMobile ? 2 : 3;
                img.style.transform = zoomed ? `scale(${zoomFactor})` : "scale(1)";
                img.style.cursor = zoomed ? "zoom-out" : "zoom-in";
                if (!isMobile) img.style.transformOrigin = "center center";
            });

            if (!isMobile) {
                wrapper.addEventListener("mousemove", e => {
                    if (!zoomed) return;
                    const rect = wrapper.getBoundingClientRect();
                    const x = ((e.clientX - rect.left) / rect.width) * 100;
                    const y = ((e.clientY - rect.top) / rect.height) * 100;
                    img.style.transformOrigin = `${x}% ${y}%`;
                });
            }
        });
    },

    initToggles() {
        document.querySelectorAll(".gc-toggle").forEach(btn => {
            btn.addEventListener("click", function () {
                const block = this.closest(".gc-block");
                const content = block.querySelector(".gc-block-content");
                const icon = this.querySelector(".gc-collapse-icon");

                block.classList.toggle("collapsed");
                content.classList.toggle("gc-collapsed");
                if (icon) icon.textContent = content.classList.contains("gc-collapsed") ? "+" : "−";
            });
        });
    },

    initLanguageSwitcher() {
        const langSelector = document.querySelector(".gc-language-selector");
        if (!langSelector) return;

        const dropdown = langSelector.querySelector(".gc-language-dropdown");
        const current = langSelector.querySelector(".gc-language-current");
        const label = current.querySelector(".gc-language-label");
        const selectedLang = this.lang || "es";

        // ✅ Get the label text directly from the <li> element
        const selectedItem = dropdown.querySelector(`li[data-lang="${selectedLang}"]`);
        if (selectedItem) {
            label.textContent = selectedItem.textContent;
        }

        // Highlight selected and handle clicks
        dropdown.querySelectorAll("li").forEach(item => {
            const lang = item.getAttribute("data-lang");
            item.classList.toggle("selected", lang === selectedLang);

            item.addEventListener("click", () => {
                const url = new URL(window.location.href);
                url.searchParams.set("iso_lang", lang);
                window.location.href = url.toString();
            });
        });

        // Dropdown toggle
        current.addEventListener("click", () => {
            dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
        });

        document.addEventListener("click", (e) => {
            if (!langSelector.contains(e.target)) {
                dropdown.style.display = "none";
            }
        });
    },

    renderExtraSustainabilityPictures() {
        const container = document.querySelector(".gc-block-content.sost-pictos");
        if (!container) return;

        try {
            const pictures = JSON.parse(container.dataset.pictos || "{}");
            const lang = this.lang || "es";
            const assetsUrl = container.dataset.assetsBase || "";

            const extraImages = (pictures.all || []).concat(pictures[lang] || []);
            if (extraImages.length === 0) return;

            extraImages.forEach(imgName => {
                const img = document.createElement("img");
                img.src = `${assetsUrl}${imgName}`;
                img.alt = imgName.split(".")[0];
                img.width = 50;
                container.appendChild(img);
            });
        } catch (e) {
            console.warn("Error parsing language-specific pictos", e);
        }
    },

    getCountryISO: async function () {
        try {
            const response = await fetch(window.location.href, { method: "HEAD" });
            const header = response.headers.get("server-timing");

            if (header) {
                const countryMatch = header.match(/country;desc="([A-Z]{2})"/);
                if (countryMatch) {
                    return countryMatch[1];
                }
            }

            const cfResponse = await fetch("https://www.cloudflare.com/cdn-cgi/trace");
            const cfData = await cfResponse.text();
            const locMatch = cfData.match(/loc=([A-Z]{2})/);
            return locMatch ? locMatch[1] : null;
        } catch (error) {
            console.warn("Unable to detect user country");
            return null;
        }
    },

    showAlternateOutput() {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        if (token === 'Webimpacto000!') return;

        const elem = document.querySelector("#gc-alternate-output");
        const container = document.querySelector(".gc-product-sheet");

        if (container) container.remove();
        if (elem) elem.style.display = "block";
    }


};

document.addEventListener("DOMContentLoaded", () => {
    GC.init();
});
